import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';

import { getActiveFilters } from 'selectors/search';
import { countries, states } from 'services/inputTokens';
import { Filter } from '../helpers';
import FilterGroup from './FilterGroup';
import { geoKeys } from './keys';
import { tagRender } from 'components/common/TagRender';
import { renderOption } from 'components/common/OptionRender';

const Geo = ({ loading }) => {
  const activeFilters = useSelector(getActiveFilters(Object.keys(geoKeys)));

  return (
    <FilterGroup
      icon='map'
      title='Location'
      activeKeys={activeFilters}
      sectionKey='geo'
    >
      <>
        <Filter
          filterType='selectIncludeExclude'
          mode={'multiple'}
          style={{ width: '100%' }}
          renderOption={renderOption}
          tagRender={tagRender}
          filterId={geoKeys.organisationGeography.key}
          placeholder='Region / Country'
          options={countries}
          disabled={loading}
        />
        <Filter
          filterType='selectIncludeExclude'
          mode={'multiple'}
          style={{ width: '100%' }}
          tagRender={tagRender}
          placeholder='State / Province'
          options={states}
          filterId={geoKeys.state.key}
          remoteSearchOnClick
          optionProp={{
            optionLabel: 'displayName',
            optionValue: 'id',
          }}
          disabled={loading}
        />
        <Filter
          filterType='token'
          placeholder='City'
          filterId={geoKeys.city.key}
          disabled={loading}
          includeExclude
        />
        <Filter
          filterType='token'
          placeholder='Zip / Postal Code'
          filterId={geoKeys.postcode.key}
          disabled={loading}
          includeExclude
        />
      </>
    </FilterGroup>
  );
};

Geo.propTypes = {
  loading: PropTypes.bool,
};

export default Geo;
